export default [
    {
        path: 'meeting/get_card/:object_type/:object_id',
        name: 'hasCard',
        meta: {
            requiresAuth: false,
            type: 'meeting'
        },
        component: () => import('@/views/meeting/getCard')
    },
    {
        path: 'meeting/status_card/:object_type/:object_id',
        name: 'statusCard',
        meta: {
            requiresAuth: true,
            type: 'meeting'
        },
        component: () => import('@/views/meeting/statusCard')
    },
    {
        path: 'meeting/copymeeting/:object_type/:object_id',
        name: 'copymeeting',
        meta: {
            requiresAuth: true,
            type: 'meeting'
        },
        component: () => import('@/views/meeting/copyMeeting')
    },
    {
        path: 'meeting/create_meeting/:object_type/:object_id/:object_name',
        name: 'createmeeting',
        meta: {
            requiresAuth: true,
            type: 'meeting'
        },
        component: () => import('@/views/meeting/createMeeting')
    },
    {
        path: 'meeting/authorize',
        name: 'authorize',
        meta: {
            requiresAuth: false,
            type: 'meeting'
        },        
        component: () => import('@/views/meeting/authorize')
    },
    {
        path: 'meeting/authorize/callback',
        name: 'authorize_callback',
        meta: {
            requiresAuth: false,
            type: 'meeting'
        },        
        component: () => import('@/views/meeting/authorizeCallback')
    },  
    {
        path: 'meeting/token/:token',
        name: 'token',
        meta: {
            requiresAuth: true,
            type: 'meeting'
        },
        component: () => import('@/views/meeting/token')
    },             
];